import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import FJBrushCardTwo from './FJBrushCardTwo';
import FJActionBrushEditCommon from '../../../redux/action/FJActionBrushEditCommon';
import FJUtil from '../../../util/FJUtil';
import useLocalStore from '../../../hooks/useLocalStore';
import FJConstant from '../../../constants/FJConstant';

const FJBrushCardTwoContainer = memo(function FJBrushCardTwoContainer(props) {
    useLocalStore();
    const dispatch = useDispatch();
    const { className } = props;

    const taskStatus = useSelector(state => state.common.taskStatus);
    const curBrushType = useSelector(state => state.brushEditCommon.curBrushType);
    const isMouseMove = useSelector(state => state.brushEditCommon.isMouseMove);
    const brashSize = useSelector(state => state.brushEditCommon.brushSize);
    const isSlideCompare = useSelector(state => state.brushEditCommon.isSlideCompare);

    const isDisabled = FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.ERROR;

    const setBrushSize = useCallback(
        (value, type = 'input') => {
            if (isDisabled) return;

            dispatch(FJActionBrushEditCommon.updateBrushSizeAction(Math.round(value), type));
        },
        [dispatch, isDisabled],
    );

    const changeBrushType = useCallback(
        value => {
            if (isDisabled) return;
            dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(value));
        },
        [dispatch, isDisabled],
    );

    return (
        <FJBrushCardTwo
            className={className}
            disabled={isDisabled}
            brashSize={brashSize}
            curBrushType={curBrushType}
            isMouseMove={isMouseMove}
            isSlideCompare={isSlideCompare}
            changeBrushType={changeBrushType}
            changeBrashSize={setBrushSize}
        />
    );
});

FJBrushCardTwoContainer.propTypes = {
    className: PropTypes.string,
};

export default FJBrushCardTwoContainer;
